import React from 'react';
import './Info.css';

const Info = () => {
    return (
        <div className="info-container">
            <div className="info">
                <h1>Let's work together and create something unique</h1>
            </div>
        </div>
    )
}

export default Info
